import type { BinaryModel } from '@ctw/shared/api/fhir/models/binary';
import { DocumentViewer } from '@ctw/shared/content/document-viewer/document-viewer';
import type { UseResourceModalOpenModalArgs } from '@ctw/shared/context/resource-modal-context';
import { tw } from '@ctw/shared/utils/tailwind';

export const binaryModalAction: UseResourceModalOpenModalArgs<'Binary'>['action'] = ({
  model,
  closeModal,
}) => ({
  label: 'Document',
  title: model.title,
  content: {
    body: <BinaryModalContent binary={model} closeModal={closeModal} />,
  },
});

interface BinaryModalContentProps {
  binary: BinaryModel;
  closeModal: () => void;
}

const BinaryModalContent = ({ binary, closeModal }: BinaryModalContentProps) => {
  return (
    <div className={tw`flex h-full max-h-screen w-full flex-col items-center`}>
      <DocumentViewer
        binaryId={binary.id}
        onClose={closeModal}
        controls={{
          search: true,
          close: true,
          download: true,
          print: true,
          openInNewTab: true,
          deepLinkSections: true,
        }}
      />
    </div>
  );
};
